import { render, staticRenderFns } from "./business-section-2.vue?vue&type=template&id=8e827140&"
import script from "./business-section-2.vue?vue&type=script&lang=js&"
export * from "./business-section-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports